import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rps_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("rps_token"))
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    localStorage.setItem("rps_token", data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data);
  };
  const register = async (email, username, password) => {
    const { data } = await api.post("/auth/register", { email, username, password });
    persist(data);
  };
  const guest = async (username) => {
    const { data } = await api.post("/auth/guest", { username: username || null });
    persist(data);
  };
  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };
  const logout = () => {
    localStorage.removeItem("rps_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, guest, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
